import http from '../Http';
import { DATA_ENDPOINTS, SUBMIT_ENDPOINTS } from '../constants/Endpoints';

class StudentUtil {
  static getStudents(config = {}) {
    return http.get(DATA_ENDPOINTS.TABLE.STUDENTS, config);
  }

  static loadAutoCompleteOptions() {
    return http.get(DATA_ENDPOINTS.STUDENT_AUTOCOMPLETE);
  }

  static updateStudent(id, data) {
    return http.put(SUBMIT_ENDPOINTS.STUDENTS.UPDATE.replace('{id}', id), data);
  }

  static deleteStudent(id) {
    return http.delete(SUBMIT_ENDPOINTS.STUDENTS.DELETE.replace('{id}', id));
  }

  static getUserIdByStudyspaceUserId = studyspaceUserId => {
    return http.get(DATA_ENDPOINTS.STUDENT_USER_ID.replace('{id}', studyspaceUserId));
  };
}

export default StudentUtil;
